import HandshqApp from '../handshq-app';

HandshqApp.SortablePositionedRecords = function (node) {
  if (this instanceof HandshqApp.SortablePositionedRecords) {
    const itemsSelector = $(node).data('items');

    this.setup = function () {
      $(node).sortable({
        update: updatePosition,
        items: `> ${itemsSelector}`,
        handle: $(node).data('handle'),
        axis: $(node).data('axis'),
        tolerance: 'pointer',
        helper: cloneWithFixedWidths,
      });
    };

    function cloneWithFixedWidths(_e, item) {
      const clone = item.clone();

      clone.children().each(function (index) {
        $(this).width(item.children().eq(index).width());
      });

      return clone;
    }

    function positionOf(item) {
      return $(node).children(itemsSelector).index(item) + 1;
    }

    function updatePosition(_e, ui) {
      $(node).sortable('disable');

      $.ajax({
        url: ui.item.data('url'),
        type: 'PATCH',
        contentType: 'application/json',
        data: JSON.stringify({
          [$(node).data('param-key')]: { position: positionOf(ui.item) },
        }),
      })
        .done(() => $(node).sortable('enable'))
        .fail(() => window.location.reload());
    }
  } else {
    throw new Error('HandshqApp.SortablePositionedRecords invoked without new');
  }
};

$(() => {
  $('.sortable-positioned-records').each(function () {
    new HandshqApp.SortablePositionedRecords(this).setup();
  });
});
